import React, { useRef, useCallback, useState } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import api from '../../../../services/api';
import { useToast } from '../../../../hooks/toast';

import Input from '../../../../components/Input';
import getResponseErrors from '../../../../utils/getResponseErrors';

type ConferidoProps = {
  CprCodigo: number;
  CprConferido: boolean;
  handleConferir(cprCodigo: number, conferido: boolean): void;
};

const Conferido: React.FC<ConferidoProps> = ({
  CprCodigo,
  CprConferido,
  handleConferir,
}) => {
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const name = `name-${CprCodigo}`;

  const [loading, setLoading] = useState(false);
  const [conferido, setConferido] = useState(CprConferido);

  const handleOnClick = useCallback(async () => {
    setLoading(true);
    try {
      await api.patch<ConferidoProps>(`pagamento/confere/${CprCodigo}`, {
        CprConferido: !conferido,
      });

      setConferido(!conferido);
      handleConferir(CprCodigo, !conferido);
    } catch (error) {
      const mensagem = getResponseErrors(error);
      addToast({
        type: 'error',
        title: 'Não foi possível atualizar informação',
        description: mensagem,
      });
    } finally {
      setLoading(false);
    }
  }, [CprCodigo, conferido, addToast, handleConferir]);

  const handleSubmit = useCallback(() => {
    console.log('clicou');
  }, []);

  return (
    <Form ref={formRef} onSubmit={handleSubmit}>
      <Input
        label=""
        disabled={loading}
        name={name}
        onClick={handleOnClick}
        type="checkbox"
        onChange={handleSubmit}
        checked={conferido}
        containerStyle={{ borderWidth: 0 }}
      />
    </Form>
  );
};

export default Conferido;
